import { Injectable } from '@angular/core';

@Injectable()
export class RegexPatternService {
    /** Caracteres ASCII imprimíveis, exceto apenas espaços em branco. */
    public get ascii(): RegExp {
        return /^(\x20*[\x21-\x7E]+\x20*)+$/;
    }

    /** Caracteres ASCII (com exceção de `;`) para definição de endereços de domínio no acesso do tipo básico. */
    public get asciiSemicolonSeparator(): RegExp {
        return /^(\x20*([\x21-\x3A]|[\x3C-\x7E])+\x20*)+$/;
    }

    /** Caracteres ASCII imprimíveis (exceto apenas espaços em branco) e letras com acentuação. */
    public get extendedAscii(): RegExp {
        return  /^(\x20*[\x21-\x7E\xA1-\xFF]+\x20*)+$/;
    }

    /** Caracteres de valores padrões para texto. */
    public get default(): RegExp {
        return /^[A-Za-z0-9 _áéíóúÁÉÍÓÚâêîôûÂÊÎÔÛÃÕãõç-]+$/;
    }

    /** Apenas caracteres alfanuméricos. */
    public get alphanumeric(): RegExp {
        return /^[A-Za-z0-9]+$/;
    }

    /** Identifica tags XML para fluxo de digitalização. */
    public get xmlTag(): RegExp {
        return /^(?!xml)[a-z_][A-Za-zÀ-ÿ0-9_.\-]*$/;
    }

    /** Identifica valores XML para fluxo de digitalização. */
    public get xmlValue(): RegExp {
        return /^((?![<>&])[\x20-\x7EÀ-ÿ])*$/;
    }

    /** Identifica variáveis para fluxo de digitalização (ex.: `[nome]`). */
    public get scanFlowVariable(): RegExp {
        return /\[(.*?)\]/g;
    }

    /** Caracteres para regras. */
    public get rule(): RegExp {
        return /^[a-zA-Z0-9\s*?:/+\\._-]+$/;
    }

    /** Caracteres para regras, excluindo `\`. */
    public get consolidateDomainRule(): RegExp {
        return /^[a-zA-Z0-9\s*?:/+._-]+$/;
    }

    /** Caracteres para regras, incluindo acentuação. */
    public get accentedRule(): RegExp {
        return /^[a-zA-ZÀ-ÿ0-9\s*?:/+\\._-]+$/;
    }

    /** Necessário conter wildcard (`?` e/ou `*`). */
    public get wildcard(): RegExp {
        return /(?:\?|\*)/;
    }

    /** Não permite `\`. */
    public get domainName(): RegExp {
        return /^[^\\]+$/;
    }

    /** Apenas endereços IP. */
    public get ipAddress(): RegExp {
        return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    }

    /** Apenas números de 0 a 9. */
    public get numbers(): RegExp {
        return /^[0-9]+$/;
    }

    /** Não permite `;` e espaços. */
    public get nddPrintAgentValue(): RegExp {
        return /^[^;\s]*$/;
    }

    /** Apenas números de 0 a 99. */
    public get quotaPercentageValue(): RegExp {
        return /^[0-9]{1,2}$/;
    }

    /** Apenas endereços que utilizem protocolo ftp ou ftps e não tenham barras duplicadas no restante e não passe a porta. */
    public get ftpProtocolAddress(): RegExp {
        return /^ftp(s)?:\/\/[^/]((?!:|\/\/).)*$/i;
    }

    /** Caminhos que não tenham barras duplicadas. */
    public get notDuplicatedForwardSlash(): RegExp {
        return /^((?!\/\/).)*$/;
    }

    /** Identifica os caracteres `{` e `}`. */
    public get hasCurlyBracket(): RegExp {
        return /\{(.*?)\}/g;
    }

    /** Identifica se inicia com `\\`. */
    public get hasDuplicatedBackslash(): RegExp {
        return /^\\\\[^\\/].*$/;
    }

    /** Apenas endereços que utilizem protocolo http ou https e não tenham barras duplicadas no restante. */
    public get httpProtocolAddress(): RegExp {
        return /^http(s)?:\/\/[^/]((?!\/\/)[A-Za-zÀ-ÿ0-9/\.\-])*$/i;
    }

    /** Identifica se existem caracteres não alfa numericos */
    public get hasSymbols(): RegExp {
        return /^.*[$-/\@#¨:-?{-~!"^_`´\\\[\]]+.*$/;
    }

    /** Identifica se existem números */
    public get hasNumber(): RegExp {
        return /^.*[0-9].*$/;
    }

    /** Identifica se existem Letras Maiúsculas */
    public get hasUpperCase(): RegExp {
        return /^.*[A-Z].*$/;
    }

    /** Identifica se existem Letras Minúsculas */
    public get hasLowerCase(): RegExp {
        return /^.*[a-z].*$/;
    }

    /**Identifica se é formato de email */
    public get email(): RegExp {
        return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    }
}
